import React, { PropsWithChildren } from 'react'
import { Breadcrumb, Breadcrumbs } from '../../components/breadcrumbs/Breadcrumbs'
import { SecondaryPageBanner } from '../../fragments/secondaryPageBanner'
import { nonNull } from '../../utils/nonNull'
import { PageQuery } from '@gql'
import { FlexibleContent } from './fragments/flexibleContent'
import { PopUpModal } from '../../components/popUpModal/PopUpModal'

export type PageProps = PageQuery

export const Page: React.FC<PropsWithChildren<PageProps>> = ({ entry, globalSet }) => {
  if (!entry || entry.__typename !== 'products_pages_product_fcp_Entry' || !entry?.secondaryPageBanner?.[0]?.__typename && entry?.secondaryPageBanner?.[0]?.__typename !== 'secondaryPageBanner_BlockType') {
    return null
  }
  
  const { image, title, primaryButton, secondaryButton, subTitle, subBanner, bannerStyle, textAlignment, secondaryButtonType, videoLink } = entry?.secondaryPageBanner?.[0]

  const bannerImage = image?.length === 0 && globalSet?.__typename === 'siteSettings_GlobalSet' ? globalSet?.flexibleContentImageFallback : image

  const breadcrumbs = (
    <Breadcrumbs>
      <Breadcrumb href={'/'} home text={'Home'} />
      {entry.parent?.parent && (
        <Breadcrumb href={`/${entry.parent.parent.uri}`} text={entry.parent.parent.title || ''} />
      )}
      {entry.parent && (
        <Breadcrumb href={`/${entry.parent.uri}`} text={entry.parent.title || ''} />
      )}
      <Breadcrumb href={`/${entry.uri}`} text={entry.title || ''} />
    </Breadcrumbs>
  )

  const popUpData = entry?.popUpModal?.[0]

  return (
    <div>
      {popUpData?.popUpStatus && popUpData?.title && (
        <PopUpModal
          title={popUpData.title}
          popUpStatus={popUpData?.popUpStatus}
          content={popUpData?.content}
          btnText={popUpData?.btnText ? popUpData?.btnText : 'Close'}
        />
      )}

      {entry?.secondaryPageBanner?.[0] && (
        <SecondaryPageBanner breadcrumbs={breadcrumbs} after={'white'} title={title} subTitle={subTitle} primaryButton={primaryButton} secondaryButton={secondaryButton} image={bannerImage} subBanner={subBanner} bannerStyle={bannerStyle} textAlignment={textAlignment} secondaryButtonType={secondaryButtonType} videoLink={videoLink} allowHeroStyle />
      )}

      {entry.flexibleContent && (
        <FlexibleContent entryId={entry.id as string} content={nonNull(entry.flexibleContent)}/>
      )}
    </div>
  )
}